<template>
  <q-page padding>
    <div class="row col-12 justify-between items-center">
      <span class="text-h6 text-weight-bold text-brand-5 texto-titulo">
        Catálogo: {{ catalogoDado?.nome }}
      </span>
      <div>
        <router-link :to="{ name: 'ferramentaria-configuracao-catalogo' }">
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row col-12 q-gutter-sm q-mt-lg">
      <div>
        <q-btn
          color="primary"
          :outline="secao != 'emprestimo'"
          label="Retirada"
          icon="build"
          class="btn-selecao"
          no-caps
          @click="secao = 'emprestimo'"
        />
      </div>
      <div>
        <q-btn
          color="black"
          label="Devolução"
          :outline="secao != 'devolucao'"
          no-caps
          class="btn-selecao"
          icon="arrow_right_alt"
          @click="secao = 'devolucao'"
        />
      </div>
      <div>
        <q-btn
          :outline="secao != 'movimentacao'"
          color="secondary"
          label="Movimentação de Status"
          no-caps
          class="btn-selecao"
          icon="sync_alt"
          @click="secao = 'movimentacao'"
        />
      </div>
      <div>
        <q-btn
          :outline="secao != 'transferencia_interna'"
          color="blue"
          label="Transferência Interna"
          no-caps
          class="btn-selecao"
          icon="move_up"
          @click="secao = 'transferencia_interna'"
        />
      </div>
      <div>
        <q-btn
          :outline="secao != 'transferencia_externa'"
          color="red"
          label="Transferência Externa"
          no-caps
          class="btn-selecao"
          icon="move_down"
          @click="secao = 'transferencia_externa'"
        />
      </div>
      <!-- <div>
        <q-btn
          :outline="secao != 'transferencia_catalogo'"
          color="red"
          label="Criação por Catálogo"
          no-caps
          class="btn-selecao"
          icon="move_down"
          @click="secao = 'transferencia_catalogo'"
        />
      </div>
      <div>
        <q-btn
          :outline="secao != 'transferencia_catalogo'"
          color="red"
          label="Criação por Voucher"
          no-caps
          class="btn-selecao"
          icon="move_down"
          @click="secao = 'transferencia_externa'"
        />
      </div> -->
    </div>
    <div class="row col-12 q-mt-xl text-brand-5">
      <div v-if="secao == 'emprestimo'" class="row col-12">
        <div class="titulo-etapa text-weight-bold">Empréstimo</div>
        <div class="row col-12 q-my-md" style="border: 2px solid"></div>
        <div class="row col-12 q-mx-md">
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Método de Autenticação - Solicitante
            </div>

            <div class="row col-12">
              <div>
                <div>
                  <q-checkbox
                    v-model="configuracoes[2].autenticacao[0].metodos"
                    label="Biometria"
                    val="biometria"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[2].autenticacao[0].metodos"
                    label="Assinatura"
                    val="assinatura"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[2].autenticacao[0].metodos"
                    label="PIN"
                    val="pin"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <!-- <q-checkbox
                    v-model="configuracoes[1].autenticacao[0].metodos"
                    label="Crachá"
                    val="cracha"
                    class="radio"
                    :disable="disable"
                    unchecked-icon="radio_button_unchecked"
                    checked-icon="radio_button_checked"
                    size="50px"
                  /> -->
                  <q-checkbox
                    v-model="configuracoes[2].autenticacao[0].metodos"
                    label="Token"
                    val="token"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                </div>
                <div class="q-mt-md q-ml-sm">
                  <div class="row col-12 text-bold subtitulo-etapa">
                    Obrigatório
                  </div>
                  <q-radio
                    v-model="configuracoes[2].autenticacao[0].obrigatorio"
                    label="Sim"
                    val="sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[2].autenticacao[0].obrigatorio"
                    label="Não"
                    val="nao"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Método de Autenticação - Almoxarife
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-checkbox
                    v-model="configuracoes[2].autenticacao[1].metodos"
                    label="Biometria"
                    val="biometria"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[2].autenticacao[1].metodos"
                    label="Assinatura"
                    val="assinatura"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[2].autenticacao[1].metodos"
                    label="PIN"
                    val="pin"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <!-- <q-checkbox
                    v-model="configuracoes[1].autenticacao[1].metodos"
                    label="Crachá"
                    val="cracha"
                    class="radio"
                    :disable="disable"
                    unchecked-icon="radio_button_unchecked"
                    checked-icon="radio_button_checked"
                    size="50px"
                  /> -->
                  <q-checkbox
                    v-model="configuracoes[2].autenticacao[1].metodos"
                    label="Token"
                    val="token"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                </div>
                <div class="q-mt-md q-ml-sm">
                  <div class="row col-12 text-bold subtitulo-etapa">
                    Obrigatório
                  </div>
                  <q-radio
                    v-model="configuracoes[2].autenticacao[1].obrigatorio"
                    label="Sim"
                    val="sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[2].autenticacao[1].obrigatorio"
                    label="Não"
                    val="nao"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Checklist
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[2].responderCheckLists"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[2].responderCheckLists"
                    val="nao"
                    label="Não"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Acessórios
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[2].responderAcessorios"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[2].responderAcessorios"
                    val="nao"
                    label="Não"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="secao == 'devolucao'" class="row col-12">
        <div class="titulo-etapa text-weight-bold">Devolução</div>
        <div class="row col-12 q-my-md" style="border: 2px solid"></div>
        <div class="row col-12 q-mx-md">
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Método de Autenticação - Solicitante
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-checkbox
                    v-model="configuracoes[0].autenticacao[0].metodos"
                    label="Biometria"
                    class="radio"
                    val="biometria"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[0].autenticacao[0].metodos"
                    label="Assinatura"
                    val="assinatura"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[0].autenticacao[0].metodos"
                    label="PIN"
                    val="pin"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <!-- <q-checkbox
                    v-model="configuracoes[0].autenticacao[0].metodos"
                    label="Crachá"
                    val="cracha"
                    class="radio"
                    :disable="disable"
                    unchecked-icon="radio_button_unchecked"
                    checked-icon="radio_button_checked"
                    size="50px"
                  /> -->
                  <q-checkbox
                    v-model="configuracoes[0].autenticacao[0].metodos"
                    label="Token"
                    val="token"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                </div>
                <div class="q-mt-md q-ml-sm">
                  <div class="row col-12 text-bold subtitulo-etapa">
                    Obrigatório
                  </div>
                  <q-radio
                    v-model="configuracoes[0].autenticacao[0].obrigatorio"
                    label="Sim"
                    val="sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[0].autenticacao[0].obrigatorio"
                    label="Não"
                    val="nao"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Método de Autenticação - Almoxarife
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-checkbox
                    v-model="configuracoes[0].autenticacao[1].metodos"
                    label="Biometria"
                    val="biometria"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[0].autenticacao[1].metodos"
                    label="Assinatura"
                    val="assinatura"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[0].autenticacao[1].metodos"
                    label="PIN"
                    val="pin"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <!-- <q-checkbox
                    v-model="configuracoes[0].autenticacao[1].metodos"
                    label="Crachá"
                    val="cracha"
                    class="radio"
                    :disable="disable"
                    unchecked-icon="radio_button_unchecked"
                    checked-icon="radio_button_checked"
                    size="50px"
                  /> -->
                  <q-checkbox
                    v-model="configuracoes[0].autenticacao[1].metodos"
                    label="Token"
                    val="token"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                </div>
                <div class="q-mt-md q-ml-sm">
                  <div class="row col-12 text-bold subtitulo-etapa">
                    Obrigatório
                  </div>
                  <q-radio
                    v-model="configuracoes[0].autenticacao[1].obrigatorio"
                    label="Sim"
                    val="sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[0].autenticacao[1].obrigatorio"
                    label="Não"
                    val="nao"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Checklist
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[0].responderCheckLists"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[0].responderCheckLists"
                    val="nao"
                    label="Não"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Acessórios
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[0].responderAcessorios"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[0].responderAcessorios"
                    val="nao"
                    label="Não"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="secao == 'movimentacao'" class="row col-12">
        <div class="titulo-etapa text-weight-bold">Movimentação de Status</div>
        <div class="row col-12 q-my-md" style="border: 2px solid"></div>
        <div class="row col-12 q-mx-md">
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Checklist
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[1].responderCheckLists"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[1].responderCheckLists"
                    val="nao"
                    label="Não"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Acessórios
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[1].responderAcessorios"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[1].responderAcessorios"
                    val="nao"
                    label="Não"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="secao == 'transferencia_interna'" class="row col-12">
        <div class="titulo-etapa text-weight-bold">Transferência Interna</div>
        <div class="row col-12 q-my-md" style="border: 2px solid"></div>
        <div class="row col-12 q-mx-md">
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Método de Autenticação
            </div>

            <div class="row col-12">
              <div>
                <div>
                  <q-checkbox
                    v-model="configuracoes[4].autenticacao[0].metodos"
                    label="Biometria"
                    val="biometria"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[4].autenticacao[0].metodos"
                    label="Assinatura"
                    val="assinatura"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                  <q-checkbox
                    v-model="configuracoes[4].autenticacao[0].metodos"
                    label="PIN"
                    val="pin"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />

                  <q-checkbox
                    v-model="configuracoes[4].autenticacao[0].metodos"
                    label="Token"
                    val="token"
                    class="radio"
                    :disable="disable"
                    size="50px"
                  />
                </div>
                <div class="q-mt-md q-ml-sm">
                  <div class="row col-12 text-bold subtitulo-etapa">
                    Obrigatório
                  </div>
                  <q-radio
                    v-model="configuracoes[4].autenticacao[0].obrigatorio"
                    label="Sim"
                    val="sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[4].autenticacao[0].obrigatorio"
                    label="Não"
                    val="nao"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Checklist
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[4].responderCheckLists"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[4].responderCheckLists"
                    val="nao"
                    label="Não"
                    class="radio"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Acessórios
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[4].responderAcessorios"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[4].responderAcessorios"
                    val="nao"
                    class="radio"
                    label="Não"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="secao == 'transferencia_externa'" class="row col-12">
        <div class="titulo-etapa text-weight-bold">Transferência Externa</div>
        <div class="row col-12 q-my-md" style="border: 2px solid"></div>
        <div class="row col-12 q-mx-md">
          <div class="row col-12">
            <div class="row col-12">
              <div class="subtitulo-etapa text-weight-bold q-mb-sm">
                Método de Autenticação
              </div>

              <div class="row col-12">
                <div>
                  <div>
                    <q-checkbox
                      v-model="configuracoes[3].autenticacao[0].metodos"
                      label="Biometria"
                      val="biometria"
                      class="radio"
                      :disable="disable"
                      size="50px"
                    />
                    <q-checkbox
                      v-model="configuracoes[3].autenticacao[0].metodos"
                      label="Assinatura"
                      val="assinatura"
                      class="radio"
                      :disable="disable"
                      size="50px"
                    />
                    <q-checkbox
                      v-model="configuracoes[3].autenticacao[0].metodos"
                      label="PIN"
                      val="pin"
                      class="radio"
                      :disable="disable"
                      size="50px"
                    />

                    <q-checkbox
                      v-model="configuracoes[3].autenticacao[0].metodos"
                      label="Token"
                      val="token"
                      class="radio"
                      :disable="disable"
                      size="50px"
                    />
                  </div>
                  <div class="q-mt-md q-ml-sm">
                    <div class="row col-12 text-bold subtitulo-etapa">
                      Obrigatório
                    </div>
                    <q-radio
                      v-model="configuracoes[3].autenticacao[0].obrigatorio"
                      label="Sim"
                      val="sim"
                      class="radio"
                      :disable="disable"
                    />
                    <q-radio
                      v-model="configuracoes[3].autenticacao[0].obrigatorio"
                      label="Não"
                      val="nao"
                      :disable="disable"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row col q-my-md q-mr-md"
              style="border: 1px solid"
            ></div>

            <div class="column col-12">
              <div class="subtitulo-etapa text-weight-bold q-mb-sm">
                Responder Checklist
              </div>
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[3].responderCheckLists"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[3].responderCheckLists"
                    val="nao"
                    class="radio"
                    label="Não"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Responder Acessórios
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[3].responderAcessorios"
                    val="sim"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[3].responderAcessorios"
                    val="nao"
                    class="radio"
                    label="Não"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col-12">
            <div class="subtitulo-etapa text-weight-bold q-mb-sm">
              Atraso Transferencia
            </div>
            <div class="row col-12">
              <div>
                <div>
                  <q-radio
                    v-model="configuracoes[3].responderAtraso"
                    :val="1"
                    label="Sim"
                    class="radio"
                    :disable="disable"
                  />
                  <q-radio
                    v-model="configuracoes[3].responderAtraso"
                    :val="0"
                    class="radio"
                    label="Não"
                    :disable="disable"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row col q-my-md q-mr-md" style="border: 1px solid"></div>
          <div
            class="row col-12 q-gutter-sm subtitulo-etapa text-weight-bold q-mb-sm"
          >
            <div>
              <div>Unidade Padrão Catálogo</div>
              <q-select
                v-model="configuracoes[5].unidadePadrao"
                :options="listaUnidades"
                dense
                @filter="filterFn"
                behavior="menu"
                option-label="nome"
                option-value="id"
                map-options
                outlined
              />
            </div>
            <div>
              <div>Unidade Padrão Voucher</div>
              <q-select
                v-model="configuracoes[6].unidadePadrao"
                :options="listaUnidades"
                dense
                behavior="menu"
                outlined
                map-options
                option-label="nome"
                option-value="id"
                @filter="filterFn"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-12 q-mt-lg q-ml-md">
      <q-btn
        label="Salvar"
        color="positive"
        icon="done"
        class="btn-salvar"
        @click="salvarConfiguracao()"
      />
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const ordemDesejada = [
      "devolucao",
      "edicao_manual",
      "emprestimo",
      "transferencia_externa",
      "transferencia_interna",
      "transferencia_manual_estoque",
      "transferencia_manual_voucher",
      "criacao_planilha",
    ];

    const catalogoDado = ref({});
    const secao = ref("emprestimo");
    const listaUnidades = ref([]);
    const configuracoes = ref([
      {
        etapa: "devolucao",
        autenticacao: [
          {
            pessoa: "solicitante",
            metodos: [],
            obrigatorio: "",
          },
          {
            pessoa: "almoxarife",
            metodos: [],
            obrigatorio: "",
          },
        ],
        responderCheckLists: "",
        responderAcessorios: "",
      },
      {
        etapa: "edicao_manual",
        responderCheckLists: "",
        responderAcessorios: "",
      },

      {
        etapa: "emprestimo",
        autenticacao: [
          {
            pessoa: "solicitante",
            metodos: [],
            obrigatorio: "",
          },
          {
            pessoa: "almoxarife",
            metodos: [],
            obrigatorio: "",
          },
        ],
        responderCheckLists: "",
        responderAcessorios: "",
      },

      {
        etapa: "transferencia_externa",
        autenticacao: [
          {
            pessoa: "autorizador",
            metodos: [],
            obrigatorio: "",
          },
        ],
        responderCheckLists: "",
        responderAcessorios: "",
        responderAtraso: "",
      },
      {
        etapa: "transferencia_interna",
        autenticacao: [
          {
            pessoa: "autorizador",
            metodos: [],
            obrigatorio: "",
          },
        ],
        responderCheckLists: "",
        responderAcessorios: "",
      },
      {
        etapa: "transferencia_manual_estoque",
        unidadePadrao: "",
      },
      {
        etapa: "transferencia_manual_voucher",
        unidadePadrao: "",
      },
    ]);
    let disable = ref(false);

    const detalharCatalogo = async () => {
      try {
        const response = await store.dispatch("ferramentaria/listarCatalogo", {
          catalogoUuid: route.params.catalogoUuid,
        });
        catalogoDado.value = response.response.data.resultado.dados[0];
      } catch (error) {
        console.log(error);
      }
    };

    const detalharConfiguracaoCatalogo = async () => {
      disable = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/configuracaoCatalogo",
          {
            catalogoUuid: route.params.catalogoUuid,
          }
        );

        if (response.data.resultado.dados.length == 0) {
          return;
        }

        configuracoes.value = response.data.resultado.dados.map((value) => {
          return {
            etapa: value.etapa,
            autenticacao: value.autenticacao || [
              {
                pessoa: "solicitante",
                metodos: [],
                obrigatorio: "",
              },
              {
                pessoa: "almoxarife",
                metodos: [],
                obrigatorio: "",
              },
            ],
            responderAtraso: value.atrasoTransferencia,
            responderCheckLists: value.responderCheckLists,
            responderAcessorios: value.responderAcessorios,
            unidadePadrao: value.unidadePadrao,
          };
        });

        configuracoes.value.sort((a, b) => {
          return (
            ordemDesejada.indexOf(a.etapa) - ordemDesejada.indexOf(b.etapa)
          );
        });

        disable = false;
      } catch (error) {
        console.log(error);
        disable = false;
      }
    };

    const salvarConfiguracao = async () => {
      let array = [];

      array = [
        {
          etapa: configuracoes.value[0].etapa,
          autenticacao: configuracoes.value[0].autenticacao,
          responderCheckLists: configuracoes.value[0].responderCheckLists,
          responderAcessorios: configuracoes.value[0].responderAcessorios,
        },
        {
          etapa: configuracoes.value[1].etapa,
          responderCheckLists: configuracoes.value[1].responderCheckLists,
          responderAcessorios: configuracoes.value[1].responderAcessorios,
        },
        {
          etapa: configuracoes.value[2].etapa,
          autenticacao: configuracoes.value[2].autenticacao,
          responderCheckLists: configuracoes.value[2].responderCheckLists,
          responderAcessorios: configuracoes.value[2].responderAcessorios,
        },
        {
          etapa: configuracoes.value[3].etapa,
          autenticacao: configuracoes.value[3].autenticacao,
          responderCheckLists: configuracoes.value[3].responderCheckLists,
          responderAcessorios: configuracoes.value[3].responderAcessorios,
          atrasoTransferencia: configuracoes.value[3].responderAtraso,
        },
        {
          etapa: configuracoes.value[4].etapa,
          autenticacao: configuracoes.value[4].autenticacao,
          responderCheckLists: configuracoes.value[4].responderCheckLists,
          responderAcessorios: configuracoes.value[4].responderAcessorios,
        },
        {
          etapa: "transferencia_manual_estoque",
          unidadePadrao:
            configuracoes.value[5]?.unidadePadrao?.id ||
            configuracoes.value[5]?.unidadePadrao,
        },
        {
          etapa: "transferencia_manual_voucher",
          unidadePadrao:
            configuracoes.value[6]?.unidadePadrao?.id ||
            configuracoes.value[6]?.unidadePadrao,
        },
      ];

      try {
        await store.dispatch("ferramentaria/salvarConfiguracao", {
          configuracoes: array,
          catalogoUuid: route.params.catalogoUuid,
        });
        quasar.notify({
          message: "Configuração salva com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalharConfiguracaoCatalogo();
      } catch (error) {
        if (
          error.response?.data.erro?.mensagem !=
          "Solicitacao incorreta, verifique 'detalhes' para mais informacao"
        ) {
          quasar.notify({
            message: error.response?.data.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data.erro?.detalhes?.configuracoes) {
          for (const key in error.response?.data.erro?.detalhes
            ?.configuracoes) {
            if (
              Object.hasOwnProperty.call(
                error.response?.data.erro?.detalhes?.configuracoes,
                key
              )
            ) {
              const element =
                error.response?.data.erro?.detalhes?.configuracoes[key];
              quasar.notify({
                message: `${key.charAt(0).toUpperCase()}${key.substring(
                  1
                )} ${element}`,
                color: "negative",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            }
          }
        }
      }
    };

    const listarUnidades = async (val) => {
      const response = await store.dispatch("org/listarUnidades");
      listaUnidades.value = response.listaUnidades;
      store.dispatch("org/saveTodasUnidade", response.listaUnidades);
      listaUnidades.value = listaUnidades.value.filter(
        (v) => v.nome.toLowerCase().indexOf(val?.toLowerCase()) > -1
      );
    };

    onMounted(() => {
      detalharCatalogo();
      detalharConfiguracaoCatalogo();
      listarUnidades();
    });

    return {
      catalogoDado,
      secao,
      configuracoes,
      salvarConfiguracao,
      listaUnidades,
      disable,
      listarUnidades,

      filterFn(val, update) {
        listarUnidades(val);
        setTimeout(() => {
          update();
        }, 300);
      },
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.texto-titulo {
  font-size: 20px;
}
.icon-voltar {
  font-size: 25px;
}
.titulo-etapa {
  font-size: 16px;
}
.subtitulo-etapa {
  font-size: 14px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin-right: 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .btn-selecao-container {
    width: 100%;
  }
  .btn-selecao {
    font-size: 11px;
    width: 175px;
    padding: 6px 0px 6px 0px;
  }
  .btn-salvar {
    font-size: 12px;
  }
  .titulo-etapa {
    font-size: 15px;
  }
  .subtitulo-etapa {
    font-size: 13px;
  }
  .radio {
    font-size: 12px;
  }
}
</style>
